"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LauncherProvider = LauncherProvider;
exports.useLauncher = useLauncher;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const embeds_1 = require("../embeds/index.js");
const launcher_1 = require("../../launcher/index.js");
const drop_launcher_param_1 = require("./drop-launcher-param");
const LauncherContext = (0, react_1.createContext)(undefined);
// Kept in memory only: a reload loses it on purpose.
function LauncherProvider({ children, parse }) {
    const embed = (0, embeds_1.useEmbed)();
    const [launcher, setLauncher] = (0, react_1.useState)();
    const embedName = embed.isEmbed ? embed.name : undefined;
    (0, react_1.useEffect)(() => {
        const value = new URL(window.location.href).searchParams.get(launcher_1.LAUNCHER_PARAM);
        if (value === null)
            return;
        setLauncher(parse(value, embedName));
        (0, drop_launcher_param_1.dropLauncherParam)();
    }, [embedName, parse]);
    return (0, jsx_runtime_1.jsx)(LauncherContext.Provider, { value: launcher, children: children });
}
function useLauncher() {
    return (0, react_1.useContext)(LauncherContext);
}
